import Konva from 'konva'
import { buildRoundedConnectionPath, connectionBulletPoints } from './connectionFlow'

export default class ConnectionFlowShape extends Konva.Shape {
    constructor(config = {}) {
        super({
            ...config,
            listening: false,
            sceneFunc(context, shape) {
                const points = connectionBulletPoints(
                    shape.connectionPath, shape.flowPhase, shape.bulletCount,
                )
                if (!points.length) return
                context.beginPath()
                for (const point of points) {
                    context.moveTo(point.x + shape.bulletRadius, point.y)
                    context.arc(point.x, point.y, shape.bulletRadius, 0, Math.PI * 2)
                }
                context.fillStrokeShape(shape)
            },
        })
        this.connectionPath = buildRoundedConnectionPath([], 0)
        this.flowPhase = 0
        this.bulletRadius = 2
        this.bulletCount = 1
        this.visible(false)
    }

    setRoute(points, cornerRadius) {
        this.connectionPath = buildRoundedConnectionPath(points, cornerRadius)
        this.visible(this.connectionPath.length > 0 && this.visible())
    }

    setFlow({ phase, bulletSize, bulletCount, visible }) {
        this.flowPhase = Number(phase) || 0
        this.bulletRadius = Math.max(0.5, (Number(bulletSize) || 1) / 2)
        this.bulletCount = Math.max(1, Math.round(Number(bulletCount) || 1))
        this.visible(Boolean(visible) && this.connectionPath.length > 0)
    }
}
